var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    height: "36px",
    width: "36px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,13.5c-0.6,0-1.1-0.5-1.1-1.1c0-0.5-0.5-1-1-1c-0.5,0-1,0.5-1,1c0,1.4,0.9,2.5,2.1,3V16c0,0.5,0.5,1,1,1 c0.5,0,1-0.5,1-1v-0.7c1.2-0.4,2.1-1.6,2.1-3c0-1.7-1.3-3-2.9-3.1c-0.8,0.1-1.4-0.5-1.4-1.1s0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1c0-1.4-0.9-2.5-2.1-3V4.4c0-0.5-0.5-1-1-1c-0.5,0-1,0.5-1,1v0.7C9.5,5.4,8.6,6.7,8.6,8 c0,1.7,1.2,3.1,3.1,3.1c0.6,0,1.1,0.5,1.1,1.1C12.9,12.9,12.4,13.5,11.8,13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,0H5.2c-0.5,0-1,0.5-1,1v34c0,0.5,0.5,1,1,1h17.6c0.2,0,0.5-0.1,0.7-0.3l7.9-7.9c0.2-0.2,0.3-0.5,0.3-0.7 V1C31.7,0.5,31.3,0,30.8,0z M23.8,32.6v-4.5h4.5L23.8,32.6z M29.7,26.1h-6.9c-0.5,0-1,0.5-1,1V34H6.2V2h23.5V26.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18,6.1h8.8c0.5,0,1-0.5,1-1s-0.5-1-1-1H18c-0.5,0-1,0.5-1,1S17.4,6.1,18,6.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18,11.3h8.8c0.5,0,1-0.5,1-1c0-0.5-0.5-1-1-1H18c-0.5,0-1,0.5-1,1C17,10.9,17.4,11.3,18,11.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18,16.5h8.8c0.5,0,1-0.5,1-1c0-0.5-0.5-1-1-1H18c-0.5,0-1,0.5-1,1C17,16,17.4,16.5,18,16.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,21.6h17.9c0.5,0,1-0.5,1-1s-0.5-1-1-1H8.8c-0.5,0-1,0.5-1,1S8.3,21.6,8.8,21.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,26.7h8.8c0.5,0,1-0.5,1-1c0-0.5-0.5-1-1-1H8.8c-0.5,0-1,0.5-1,1C7.9,26.3,8.3,26.7,8.8,26.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,31.9h8.8c0.5,0,1-0.5,1-1c0-0.5-0.5-1-1-1H8.8c-0.5,0-1,0.5-1,1C7.9,31.4,8.3,31.9,8.8,31.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.d86c1520.svg";
export { ForwardRef as ReactComponent };